/* eslint-disable no-console */
import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Position } from '../../models/position.model'
import { PositionsService } from './positions.service'

const EXTERNAL_FILE_MANAGER_HOST = 'helios-external-overview'
const POSITION_URL = `${EXTERNAL_FILE_MANAGER_HOST}/positions`

@Injectable({
  providedIn: 'root',
})
export class HttpPositionsService extends PositionsService {
  constructor(private readonly httpClient: HttpClient) {
    super()
  }

  getPositions(executionId: number): Observable<Position[]> {
    return this.httpClient.get<Position[]>(POSITION_URL, {
      params: new HttpParams().set('executionId', executionId),
    })
  }
}
